<template>
	<div>
		<loading v-if="!loaded" />
		<div class="md-layout" v-if="loaded">
			<div class="md-layout-item md-small-size-100 md-size-100"
				style="display: flex; justify-content:space-between; align-items: center;">
				<h3 class="order-title">Investment Information</h3>
				<div>
					<!-- <a :href="'#/print_loan_contract/' + loan.hash_id" target="_blank">
						<md-button class="md-just-icon md-simple md-primary">
							<md-icon>article</md-icon>
							<md-tooltip>Loan Contract</md-tooltip>
						</md-button>
					</a>
					<a :href="'#/print_loan/' + loan.hash_id" target="_blank">
						<md-button class="md-just-icon md-simple md-primary">
							<md-icon>print</md-icon>
							<md-tooltip>Loan Payment</md-tooltip>
						</md-button>
					</a> -->
				</div>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-50">
				<table>
					<tr>
						<td style="width: 150px">Investment amount</td>
						<td style="width: 40px">:</td>
						<td>{{config.moneylify(investment.amount)}}</td>
					</tr>
					<tr>
						<td>Investment term</td>
						<td>:</td>
						<td>{{investment.term}} Months</td>
					</tr>
					<tr>
						<td>Interest rate</td>
						<td>:</td>
						<td>{{investment.interest_rate}}%</td>
					</tr>
					<tr>
						<td>Total interest</td>
						<td>:</td>
						<td>{{config.moneylify(investment.interest_amount)}}</td>
					</tr>
					<tr>
						<td>Investment fee</td>
						<td>:</td>
						<td>{{config.moneylify(investment.investment_fee)}}</td>
					</tr>
					<tr>
						<td>Total payment</td>
						<td>:</td>
						<td><b>{{config.moneylify(investment.total_payment)}}</b></td>
					</tr>
					<tr>
						<td>Status</td>
						<td>:</td>
						<td>
							<span class="active"
								v-if="investment.status == 'act'">{{config.getStatus(investment.status)}}</span>
							<span class="late" v-if="investment.status == 'fin'">{{config.getStatus(investment.status)}}</span>
						</td>
					</tr>

				</table>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-50">
				<table style="border-width: 0px;">
					<tr>
						<td>Investor</td>
						<td>:</td>
						<td>{{investment.name}}</td>
					</tr>
					<tr>
						<td style="width: 150px">Initial payment</td>
						<td style="width:40px">:</td>
						<td>{{config.moneylify(investment.initial_payment)}}</td>
					</tr>
					<tr>
						<td>Monthly payment</td>
						<td>:</td>
						<td>{{config.moneylify(investment.monthly_payment)}}</td>
					</tr>
					<tr>
						<td>Final payment</td>
						<td>:</td>
						<td>{{config.moneylify(investment.final_payment)}}</td>
					</tr>
					<tr>
						<td>Paid EMIs</td>
						<td>:</td>
						<td>{{investment.total_paid}} / {{investment.term}}</td>
					</tr>
					<!-- <tr>
					<td>Remaining balance</td>
					<td>:</td>
					<td>{{config.moneylify(investment.loan_balance)}}</td>
				</tr> -->
					<tr>
						<td>Investment period</td>
						<td>:</td>
						<td>{{config.datelify(investment.start_date)}} - {{config.datelify(investment.end_date)}}</td>
					</tr>
					<tr>
						<td>Next payment</td>
						<td>:</td>
						<td>
							<span v-if="investment.total_paid == investment.term">N/A</span>
							<span class="active"
								v-else-if="String(investment.next_payment).length >0">{{config.datelify(investment.next_payment)}}</span>
						</td>
						<!-- <td><span class="late" v-if="false">12/11/2021</span></td> -->
					</tr>
				</table>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-100">
				<h3 class="order-title">Investment Remark</h3>
				<p v-if="String(investment.note).length > 0">{{investment.note}}</p>
				<p v-else>Not available</p>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-100">
				<h3 class="order-title">Payment History</h3>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-100">
				<md-table v-if="paymentList.length > 0">
					<md-table-row>
						<md-table-head>Term</md-table-head>
						<md-table-head>Payment ID</md-table-head>
						<md-table-head>Payment Date</md-table-head>
						<md-table-head>Total</md-table-head>
						<md-table-head>Principal</md-table-head>
						<md-table-head>Interest</md-table-head>
						<md-table-head>Total</md-table-head>
						<md-table-head>Principal Balance</md-table-head>
						<md-table-head>Balance</md-table-head>
						<md-table-head>Status</md-table-head>
						<md-table-head>Action</md-table-head>
					</md-table-row>

					<md-table-row v-for="(payment, index) in paymentList">
						<md-table-cell>{{ payment.term_id }}</md-table-cell>
						<md-table-cell>{{ payment.hash_id }}</md-table-cell>
						<md-table-cell>{{ config.datelify(payment.created_date) }}</md-table-cell>
						<md-table-cell>{{ config.moneylify(payment.currentTotal) }}</md-table-cell>
						<md-table-cell>{{ config.moneylify(payment.principal) }}</md-table-cell>
						<md-table-cell>{{ config.moneylify(payment.interest) }}</md-table-cell>
						<md-table-cell><b>{{ config.moneylify(payment.interest + payment.principal)}}</b></md-table-cell>
						<md-table-cell>{{ config.moneylify(payment.balance) }}</md-table-cell>
						<md-table-cell>{{ config.moneylify(payment.interestBalance) }}</md-table-cell>
						<md-table-cell>
							<span class="late" v-if="payment.status == 'pnd'">{{ config.getStatus(payment.status) }}</span>
							<span class="active" v-if="payment.status == 'pad'">{{ config.getStatus(payment.status) }}</span>
						</md-table-cell>
						<md-table-cell>
							<md-button class="md-just-icon md-simple md-primary"
								v-if="payment.created_date > ((new Date()).getTime() / 1000) && payment.status=='pnd'"
								@click="payPayment(payment.id)">
								<md-icon>price_check</md-icon>
								<md-tooltip md-direction="top">Pay</md-tooltip>
							</md-button>
							<md-button class="md-just-icon md-simple md-danger"
								v-if="payment.created_date < ((new Date()).getTime() / 1000) && payment.status =='pnd'"
								@click="openLateDialog(payment.id)">
								<md-icon>price_check</md-icon>
								<md-tooltip md-direction="top">Pay as late</md-tooltip>
							</md-button>
							<span v-if="payment.status=='pad'">{{config.datelify(payment.paid_date)}}</span>
						</md-table-cell>
					</md-table-row>
				</md-table>
			</div>
			<div class="md-layout-item md-size-100 text-right"
				v-if="investment.status != 'fin' && investment.total_paid < investment.term - 1">
				<md-button class="md-raised md-primary" @click="payAllDialog = true">
					Pay All</md-button>
			</div>
		</div>
		<md-dialog-confirm :md-active.sync="payDialog" md-title="Are you sure want to mark this as paid ?" md-content=""
			md-confirm-text="OK" md-cancel-text="Cancel" @md-cancel="onCancel" @md-confirm="payPayment" />

		<md-dialog-prompt :md-active.sync="payAllDialog"
			:md-title="'Are you sure want to finish this investment ? Total principal is ' + config.moneylify(payAllPrincipal)"
			md-content="" md-confirm-text="OK" md-cancel-text="Cancel" md-input-maxlength="8"
			md-input-placeholder="Total interest" md-input-name="Test" @md-cancel="onCancel" @md-confirm="payAllPayment"
			v-model="payAllInterest" />

		<md-dialog-prompt :md-active="lateDialog" md-title="Late Payment Fee" md-confirm-text="Confirm"
			md-cancel-text="Cancel" md-input-maxlength="8" md-input-placeholder="Fee ($)" @md-cancel="onCancel"
			@md-confirm="payLatePayment()" v-model="lateFee" ref="dialog" />
	</div>
</template>
<script>
	export default {
		created() {
			this.getInvestment();
			this.getPayment();
			this.getPayAllTotal();
		},
		data() {
			return {
				loaded: false,
				paymentList: [],
				payDialog: false,
				lateDialog: false,
				payAllDialog: false,
				payID: "",
				payLateID: "",
				lateFee: "",
				payAllPrincipal: 0,
				payAllInterest: "",
				investment: {
					id: "",
					hash_id: "",
					interest_amount: "",
					investment_fee: "",
					total_payment: "",
					amount: "",
					term: "",
					initial_payment: "",
					monthly_payment: "",
					start_date: "",
					end_date: "",
					name: "",
					phone: "",
					next_payment: "",
					loan_balance: "",
					total_paid: "",
					note: "",
					status: ""
				},
			}
		},
		methods: {
			getInvestment(offset = 0, replace = true) {
				this.$http.get(this.config.api + "/admin/investment/get/" + this.$route.params.hash_id).then(data => {
					this.investment = data.body.data
					this.loaded = true
				})
			},
			getPayment() {
				this.$http.get(this.config.api + "/admin/investment/get_payment/" + this.$route.params.hash_id).then(data => {
					this.paymentList = data.body.data
				})
			},
			getPayAllTotal() {
				this.$http.get(this.config.api + "/admin/investment/get/pay_all/" + this.$route.params.hash_id).then(data => {
					this.payAllPrincipal = data.body.data.balance
					// this.payAllInterest = data.body.data.fine
				})
			},
			payPayment(id = "") {
				if (id == "" && String(this.payID).length > 0) {
					this.$http.post(this.config.api + "/admin/investment/pay/payment", {
						payment_id: this.payID,
						late_fee: "0",
						investment_id: this.investment.id
					}).then(data => {
						if (data.body.status == 'success') {
							this.getPayment();
							this.getInvestment();
						}
					})
				} else {
					this.payID = id;
					this.payDialog = true;
				}

			},
			openLateDialog(id) {
				this.lateDialog = true;
				this.payLateID = id;
			},
			payLatePayment() {

				let id = this.payLateID;
				let fee = this.lateFee;
				this.onCancel();
				if (String(id).length > 0 && String(fee).length > 0) {
					this.$http.post(this.config.api + "/admin/investment/pay/payment", {
						payment_id: id,
						late_fee: fee,
						investment_id: this.investment.id
					}).then(data => {
						if (data.body.status == 'success') {
							this.getPayment();
							this.getInvestment();
						}
					})
				}

			},
			payAllPayment() {
				this.$http.post(this.config.api + "/admin/investment/pay_all/payment", {
					investment_id: this.investment.id,
					interest: this.payAllInterest
				}).then(data => {
					if (data.body.status == 'success') {
						this.getPayment();
						this.getInvestment();
					}
				})
			},
			onCancel() {
				this.payDialog = false;
				this.lateDialog = false;
				this.payID = "";
				this.lateFee = "";
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/Investment/Detail.vue